<template>
<div class="input-group">

  <div class="timepicker input-controls-container clearfix" role="presentation">
    
    <input 
      type="text" 
      :id="id"
      class="form-control timepicker__input ui-timepicker-input" 
      v-model="timeInput" 
      @keydown="inputKeyDown"
      v-mask="'##:##'"
      :placeholder="placeholder"
      ref="input"
      :aria-describedby="id + '_description'"
      />

      <div :id="id + '_description'" class="sr-only">
        strzalka w lewo wybór godzin,
        strzalka w prawo wybór minut,
        strzałki góra dół zmiana wartości
      </div>

      <div class="sr-only" aria-live="assertive">
        <span v-if="show">
          <span v-if="selecting == 'hours'">Wybór godziny</span>
          <span v-if="selecting == 'minutes'">Wybór minut</span>
        </span>
      </div>
      <!-- v-mask="{mask: '99:99', greedy: true}" -->
    <div class="input-controls jsInputTimepickerControls" role="presentation">
        <span title="Kliknięcie powoduje dodanie do godziny 30 minut" class="prev icon-angle-top" @click="addTime(30)"></span>
        <span title="Kliknięcie powoduję odjęcie od godziny 30 minut" class="next icon-angle-bottom" @click="addTime(-30)"></span>
    </div>
  </div>
  <div v-show="show" class="timepicker__list" ref="list" :aria-hidden="!show">
    <ul class="timepicker__list-hours"  ref="listHours" :class="{active : selecting == 'hours'}" @mouseenter="selecting = 'hours'">
      <li v-for="(item,idx) in hourList" :key="idx" class="timepicker__list-item" :class="{active : item == hours}">
        <a href="#"  @click.prevent="hours = item; setFocus()" >{{item}}</a>
      </li>
    </ul>
    <ul class="timepicker__list-minutes"  ref="listMinutes" :class="{active : selecting == 'minutes'}" @mouseenter="selecting = 'minutes'">
      <li v-for="(item,idx) in minuteList" :key="idx" class="timepicker__list-item" :class="{active : item == minutes}">
        <a href="#"  @click.prevent="minutes = item; setFocus()" >{{item}}</a>
      </li>
    </ul>
  </div>
  
</div>
</template>

<script>
import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import VueScrollTo from 'vue-scrollto'


export default {
  name: 'IcTimePicker',
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    v: {
      type: Object
    },
    step: {
      type: Number,
      default: 15
    },
    placeholder: {
      type: String,
      default: 'HH:MM'
    }
  },
  data() {
    let hourList = [];
    for(let i = 0; i < 24; i++) {
      hourList.push(this.leadZero(i))
    }

    let minuteList = [];
    for(let i = 0; i < 60; i++) {
      minuteList.push(this.leadZero(i))
    }

    return {
      show: false,
      hours : '',
      minutes : '',
      hourList,
      minuteList,
      selecting: 'hours',
      hideTO: null
    }
  },
  computed: {
    timeInput: {
      get: function() {
        return this.formatTime(this.hours,this.minutes);
      },
      set: function(v) {
        let timeArr = v.replace(/_/g, '').split(':')
        this.hours = timeArr[0];
        this.minutes = timeArr[1];
      }
    }
  },
  updated(){

  },
  methods: {
    inputKeyDown: function(event) {
      let keys = [':', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
      let s = this.selecting
      let v = null;

      if (keys.indexOf(event.key) > -1) {
        event.preventDefault()
      }

      switch(event.key) {
        case ':' :
          this.hours = this.leadZero(this.hours);
          break
        case 'ArrowLeft' :
        case 'Left' :
          this.selecting = 'hours'
          break; 
        case 'ArrowRight' :
        case 'Right' :
          this.selecting = 'minutes'
          if (this.hours == '') {
            this.hours = '00';
            if (this.minutes == '') {
              this.minutes = '00'
            }
          }

          break;
        case 'ArrowUp' :
        case 'Up' :
          v = parseInt(this[s]) || 0
          if (v > 0) {
            this[s] = this.leadZero(v - 1)
          }
          break;
        case 'ArrowDown' :
        case 'Down' :
          let max = this.selecting == 'hours' ? 23 : 59
          v = parseInt(this[s]) || 0
          if (v < max) {
            this[s] = this.leadZero(v + 1)
          }
          break;
      }
    },
    setFocus: function() {
      clearTimeout(this.hideTO)
      this.$refs.input.focus()
    },
    addTime: function(minutes) {
        this.modifyTime(minutes)
    },
    _setTime: function(t) {
      this.time = t;
      if (this.v) {
        this.v.$touch()
      }
      return t;
    },
    modifyTime: function(minutes) {
      let h = parseInt(this.hours) || 0
      let m = parseInt(this.minutes) || 0
      let t = h * 60 + m + minutes;
      t = t >= 0 ? (t >= 1440 ? t - 1440 : t) : 1440 + t
      h = Math.floor(t / 60)
      m = t % 60
      
      this.hours = this.leadZero(h)
      this.minutes = this.leadZero(m)
    },
    leadZero: (value) => value < 10 ? (value !== '' ? '0' + ('' + value).replace(/^0([0-9])/, '$1') : '' ) : value,
    formatTime: function(h,m) {
      return h + (m ? ':' + m : (h && h.length >= 2 ? ':' : ''))
    }
  },
  watch: {
    'hours' : function(v) {
      this.$nextTick(function() {
        let hours = this.$refs.listHours
        let active = hours.querySelector('.active');
        if (active) {
          hours.scrollTop = active.offsetTop - (hours.offsetHeight / 2);
        }
        this.selecting = 'hours'
        this.$emit('input', this.timeInput)
      })
    },
    'minutes' : function(v) {
      this.$nextTick(function() {
        let minutes = this.$refs.listMinutes
        let active = minutes.querySelector('.active');
        if (active) {
          minutes.scrollTop = active.offsetTop - (minutes.offsetHeight / 2);
        }    
        this.selecting = 'minutes'
        this.$emit('input', this.timeInput)
      });
    },
  },
  components: {

  }
}
</script>


<style lang="scss">
  $col-ic-blue: #0076c8;
  $col-ic-blue-hover: #128ee4;
  $col-ic-orange: #f58220;
  $col-ic-gray: #ebebeb;
  $col-ic-highcontrast-text: #fff200;
  $col-ic-highcontrast-input-bg: #3a3a3a;

  .timepicker {
    position: relative;
  }

  .timepicker__list {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 100;
    background: $col-ic-gray;
    
    font-size: 18px;
    height: 300px;
    max-width: 100px;
    overflow: hidden;
  }

  .timepicker__list-hours,
  .timepicker__list-minutes {
    position: relative;
    width: 50%;
    list-style-type: none;
    margin: 0;
    padding: 0;
    float: left;
    max-height: 100%;
    overflow-y: scroll;
  }

  .timepicker__list-item {
    opacity: 0.3;
  }

  .active .timepicker__list-item {
    opacity: 1;
  }

  .timepicker__list-item.active {
    opacity: 1;
  }

  .timepicker__list-item a {
    display: block;
    padding: 0 10px;
    color: inherit;
  }

 .timepicker__list-item.active a {
    color: $col-ic-blue;
  }

  .timepicker__list-item a:hover {
    background: darken($col-ic-gray, 20%);
    text-decoration: none;
  }

  #high-contrast {
    .timepicker__list {
      background: $col-ic-highcontrast-input-bg;
    }
    .timepicker__list-item a:hover {
      background: $col-ic-highcontrast-text;
      color: $col-ic-highcontrast-input-bg;;
    }
  }
</style>
